import { render, staticRenderFns } from "./oidc.vue?vue&type=template&id=aa64be5c&"
import script from "./oidc.vue?vue&type=script&lang=js&"
export * from "./oidc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports